// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lf-tool-overlay{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;pointer-events:none;overflow:hidden}.lf-tool-overlay>*{pointer-events:all}.lf-keyboard-tips{float:right}.lf-node-select-decorate{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);pointer-events:none;border:1px dashed #343435;position:absolute}", ""]);
// Exports
module.exports = exports;
